import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { FormRendererModule } from '@features/forms/form-renderer-module';
import { RuleAutomationModule } from '@features/rule-automation/rule-automation.module';
import { TranslateAutomationPageComponent } from '../translation/translate-automation-page/translate-automation-page.component';
import { ProgramAutomationModalFooterButtonPipe } from './pipes/program-automation-modal-footer-button.pipe';
import { ProgramAutomationBuilderDetailsComponent } from './program-automation-builder/program-automation-builder-details/program-automation-builder-details.component';
import { ProgramAutomationBuilderFallbackComponent } from './program-automation-builder/program-automation-builder-fallback/program-automation-builder-fallback.component';
import { ProgramAutomationBuilderModalComponent } from './program-automation-builder/program-automation-builder-modal/program-automation-builder-modal.component';
import { ProgramAutomationBuilderRulesComponent } from './program-automation-builder/program-automation-builder-rules/program-automation-builder-rules.component';
import { ProgramAutomationBuilderShareComponent } from './program-automation-builder/program-automation-builder-share/program-automation-builder-share.component';
import { ProgramAutomationRouteModalComponent } from './program-automation-builder/program-automation-route-modal/program-automation-route-modal.component';
import { ProgramAutomationTableComponent } from './program-automation-table/program-automation-table.component';

@NgModule({
  imports: [
    GCCoreModule,
    FormRendererModule,
    RuleAutomationModule
  ],
  declarations: [
    ProgramAutomationTableComponent,
    TranslateAutomationPageComponent,
    ProgramAutomationBuilderModalComponent,
    ProgramAutomationBuilderDetailsComponent,
    ProgramAutomationBuilderRulesComponent,
    ProgramAutomationBuilderFallbackComponent,
    ProgramAutomationBuilderShareComponent,
    ProgramAutomationRouteModalComponent,
    ProgramAutomationModalFooterButtonPipe
  ],
  exports: [
    ProgramAutomationTableComponent,
    TranslateAutomationPageComponent
  ]
})
export class ProgramAutomationModule { }
